module.exports = __webpack_public_path__ + "2840956ab9eaafb92c45e78fc483d46a.png";